export const INVENTORY_ITEM_ATTACHMENT = {
  ACCEPTED_FILE_TYPES: [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.xlsb',
    '.xps',
    '.pptx',
    '.jpg',
    '.jpeg',
    '.png',
    '.txt',
    '.csv',
    '.html',
    '.mp4',
    '.msg',
    '.pub',
    '.rtf',
    '.tif',
    '.zip',
  ],
  FILE_SIZE_LIMIT: 1024,
};

export const SECTIONS_LABELS = {
  PRIMARY_MITIGATION_ACTION: 'Mitigation information',
  LOCATION_INFORMATION: 'Location information',
  STRUCTURE_ATTRIBUTES: 'Structure attributes',
  BUILDING_INSURANCE_INFORMATION: 'Insurance information',
  INFRASTRUCTURE_INSURANCE_INFORMATION: 'Insurance information',
  COST_EFFECTIVENESS_INFORMATION: 'Cost-effectiveness information',
  GREENSPACE_ACREAGE: 'Acreage turned to green space',
  OWNER_INFORMATION: 'Owner information',
};

export const PROPERTY_TYPES_LABELS = {
  BLDG: 'building',
  INFRA: 'infrastructure/utility/other',
  VACLAND: 'vacant land',
};

export const PROPERTY_TYPES_CODES = {
  BUILDING: 'BLDG',
  INFRASTRUCTURE: 'INFRA',
  VACANTLAND: 'VACLAND',
};

export const RADIO_OPTIONS = [
  {label: 'Yes', value: true},
  {label: 'No', value: false},
];

export const STRUCTRE_INSURANCE_OPTIONS = {
  nfip: 'National Flood Insurance Program (NFIP)',
  private: 'Private insurance',
  self: 'Self',
};

export const RESIDENCE_STRUCTURE_TYPES = [
  {
    text: 'Primary residence',
    value: 'Primary residence',
    key: 1,
  },
  {
    text: 'Secondary residence',
    value: 'Secondary residence',
    key: 2,
  },
  {
    text: 'Not owner occupied',
    value: 'Not owner occupied',
    key: 3,
  },
];

export const INVENTORY_TYPE_CODES = {
  BUILDING: 536,
  INFRASTRUCTURE: 537,
  VACANTLAND: 538,
};

export const NEW_ITEM = {
  psiProjectId: 0,
  subapplicationId: '',
  projectSiteInventoryId: 0,
  ownerSameAddressAsProperty: null,
  ownerHasCoowner: null,
  coownerSameAddressAsOwner: null,
  coownerSameAddressAsProperty: null,
  residenceType: '',
  ownerType: '',
  coownerType: '',
  additionalComments: '',
  structure: {
    inventoryType: '',
    yearBuilt: null,
    buildingSize: null,
    lotSize: null,
    landProposedUse: null,
    otherLandProposedUse: null,
    structureType: '',
    structureTypePrimary: '',
    structureTypeSecondary: '',
    propertyTaxId: '',
    legalDescription: '',
    foundationType: '',
    baseFloodElevation: null,
    firstFloorElevation: null,
    feetAboveBfe: null,
  },
  location: {
    addressId: 0,
    projectSiteId: 0,
    addr1: '',
    addr2: '',
    state: '',
    city: '',
    county: '',
    zip: '',
    zip4: '',
    latitude: null,
    longitude: null,
  },
  owner: {
    ownerId: 0,
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '',
    primaryPhone: '',
    secondaryPhone: '',
    email: '',
    companyName: '',
    address: {
      addressId: 0,
      addr1: '',
      addr2: '',
      state: '',
      county: '',
      city: '',
      zip: '',
      zip4: '',
    },
    coowner: {
      ownerId: 0,
      firstName: '',
      middleName: '',
      lastName: '',
      suffix: '',
      primaryPhone: '',
      secondaryPhone: '',
      email: '',
      companyName: '',
      address: {
        addressId: 0,
        addr1: '',
        addr2: '',
        state: '',
        city: '',
        county: '',
        zip: '',
        zip4: '',
      },
    },
  },
  payload: {
    structureAdditionalInformation: {otherFoundationDescription: ''},
    insurance: {
      propertyInsured: null,
      nfipInsured: null,
      self: null,
      nfipPolicyNumber: '',
      naicCompanyName: '',
      otherCompanyName: '',
    },
    repetitiveLoss: {
      structure: null,
      severe: null,
      propertyLocatorNumber: '',
    },
    substantiallyDamaged: null,
    estimatedPurchaseAmount: null,
    costEffectiveness: {
      method: '',
      other: '',
      benefitCostRatio: null,
    },
    currentlyRented: null,
    critcalFacility: null,
    alternateStructure: null,
    floodZone: [''],
    primaryHazards: [''],
    secondaryHazards: [],
    primaryHazardsOther: '',
    secondaryHazardsOther: '',
    primaryMitigationAction: '',
    secondaryMitigationActions: '',
  },
};

export const MODALS = {
  MANAGE: 'manage',
  DELETE: 'delete',
  NONE: 'none',
};

export const ADD_LOCATION_METHOD_CHANGE_OPTIONS = [
  {
    text: 'Select',
    value: null,
    key: 1,
  },
  {
    text: 'Import property/structure(s) to the project site inventory using template',
    value: 'excel',
    key: 2,
  },
  {
    text: 'Manually add property/structure(s) to the project site inventory',
    value: 'enter',
    key: 3,
  },
];

// This is to "break" one radio group to several and conditionally render other fields in between
export const COST_EFFECTIVNESS_OPTION_PARTS = {
  1: [1, 2],
  2: [3, 4],
  3: [5],
};

export const PRECALC_BENEFITS_OPTIONS = [
  {
    text: 'Acquisitions in the special flood hazard area',
    name:
      'payload.costEffectiveness.preCalcBenefits.acquisitionsInSpecialFloodHazardArea',
    value: 'acquisitionsInSpecialFloodHazardArea',
  },
  {
    text: 'Elevations in the special flood hazard area',
    name: 'payload.costEffectiveness.preCalcBenefits.elevationsInSpecialFloodHazardArea',
    value: 'elevationsInSpecialFloodHazardArea',
  },
  {
    text: 'Mitigation reconstruction in the special flood hazard area',
    name:
      'payload.costEffectiveness.preCalcBenefits.mitgationReconstructionInSpecialFloodHazardArea',
    value: 'mitgationReconstructionInSpecialFloodHazardArea',
  },
  {
    text: 'Individual tornado safe rooms',
    name: 'payload.costEffectiveness.preCalcBenefits.tornadoSafeRooms',
    value: 'tornadoSafeRooms',
  },
  {
    text: 'Residential hurricane wind retrofits',
    name: 'payload.costEffectiveness.preCalcBenefits.hurricaneWindRetrofit',
    value: 'hurricaneWindRetrofit',
  },
  {
    text: 'Non-residential hurricane wind retrofits',
    name: 'payload.costEffectiveness.preCalcBenefits.nonResidentialHurricaneWindRetrofit',
    value: 'nonResidentialHurricaneWindRetrofit',
  },
  {
    text: 'Post-wildfire mitigation',
    name: 'payload.costEffectiveness.preCalcBenefits.postWildfireMitigation',
    value: 'postWildfireMitigation',
  },
];
